import { render, staticRenderFns } from "./VersoImpressao.vue?vue&type=template&id=de7b329a&scoped=true&"
import script from "./VersoImpressao.vue?vue&type=script&lang=js&"
export * from "./VersoImpressao.vue?vue&type=script&lang=js&"
import style0 from "./VersoImpressao.vue?vue&type=style&index=0&id=de7b329a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7b329a",
  null
  
)

export default component.exports